import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap";
import { ModalPlainSelectors } from "./ModalPlainSelectors";
import Icon from "../Icon/Icon";
export interface ModalPlainProps {
  isOpen: boolean;
  handleClose: () => void;
  title: string | JSX.Element;
  children: ReactNode;
  className?: string;
  ["data-cy"]?: string;
  onClickBackArrow?: () => void;
}

export const ModalPlain: FC<ModalPlainProps> = (props) => {
  const { isOpen, handleClose, title, children, className } = props;
  const modalWrapperClassNames = classNames("fds-modal-wrapper", className);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      {...{
        className: modalWrapperClassNames,
        isOpen,
      }}
      toggle={handleClose}
      data-cy={props["data-cy"]}
    >
      <ModalBody
        className="pt-4 pb-4 pl-4 pr-4"
        data-cy={ModalPlainSelectors.block}
      >
        <Row className="mr-1">
          <Col>
            <CardTitle
              tag="h4"
              className="m-0 fds-heading-400 fds-letter-spacing-wide fds-modal-title"
            >
              {props.onClickBackArrow && (
                <div
                  role="button"
                  data-cy={ModalPlainSelectors.backButon}
                  onClick={props.onClickBackArrow}
                >
                  <Icon
                    customClassName="ml-2 d-inline fds-text-blue-900"
                    icon={"chevronLeft"}
                  />
                </div>
              )}
              {title}
            </CardTitle>
          </Col>
          <div
            onClick={handleClose}
            className="fds-heading-400 fds-modal-close-button"
            role="button"
            data-cy={ModalPlainSelectors.dismissButon}
          >
            &times;
          </div>
        </Row>
        <div className="fds-modal-body">{children}</div>
      </ModalBody>
    </Modal>
  );
};
